module.exports = __webpack_public_path__ + "img/active-btn.30098e35.gif";